"use strict";

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var effects_1 = require("redux-saga/effects");

var react_router_redux_1 = require("react-router-redux");

var notificationActions_1 = require("../actions/notificationActions");

var authActions_1 = require("../actions/authActions");

var fetchActions_1 = require("../actions/fetchActions");

var auth_1 = require("../auth");

var nextPathnameSelector = function nextPathnameSelector(state) {
  var locationState = state.router.location.state;
  return locationState && locationState.nextPathname;
};

var currentPathnameSelector = function currentPathnameSelector(state) {
  return state.router.location;
};

exports.default = function (authProvider) {
  if (!authProvider) {
    return function () {
      return null;
    };
  }

  function handleAuth(action) {
    var type, payload, error, meta, _a, authPayload, redirectTo, e_1, errorMessage, error_1, e_2, nextPathname;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          type = action.type, payload = action.payload, error = action.error, meta = action.meta;
          _a = type;

          switch (_a) {
            case authActions_1.USER_LOGIN:
              return [3
              /*break*/
              , 1];

            case authActions_1.USER_CHECK:
              return [3
              /*break*/
              , 11];

            case authActions_1.USER_LOGOUT:
              return [3
              /*break*/
              , 17];

            case fetchActions_1.FETCH_ERROR:
              return [3
              /*break*/
              , 20];
          }

          return [3
          /*break*/
          , 29];

        case 1:
          _b.trys.push([1, 7,, 10]);

          return [4
          /*yield*/
          , effects_1.put({
            type: authActions_1.USER_LOGIN_LOADING
          })];

        case 2:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.call(authProvider, auth_1.AUTH_LOGIN, payload)];

        case 3:
          authPayload = _b.sent();
          return [4
          /*yield*/
          , effects_1.put({
            type: authActions_1.USER_LOGIN_SUCCESS,
            payload: authPayload
          })];

        case 4:
          _b.sent();

          return [4
          /*yield*/
          , meta.pathName || effects_1.select(nextPathnameSelector)];

        case 5:
          redirectTo = _b.sent();
          return [4
          /*yield*/
          , effects_1.put(react_router_redux_1.push(redirectTo || '/'))];

        case 6:
          _b.sent();

          return [3
          /*break*/
          , 10];

        case 7:
          e_1 = _b.sent();
          return [4
          /*yield*/
          , effects_1.put({
            type: authActions_1.USER_LOGIN_FAILURE,
            error: e_1,
            meta: {
              auth: true
            }
          })];

        case 8:
          _b.sent();

          errorMessage = typeof e_1 === 'string' ? e_1 : typeof e_1 === 'undefined' || !e_1.message ? 'ra.auth.sign_in_error' : e_1.message;
          return [4
          /*yield*/
          , effects_1.put(notificationActions_1.showNotification(errorMessage, 'warning'))];

        case 9:
          _b.sent();

          return [3
          /*break*/
          , 10];

        case 10:
          return [3
          /*break*/
          , 29];

        case 11:
          _b.trys.push([11, 13,, 16]);

          return [4
          /*yield*/
          , effects_1.call(authProvider, auth_1.AUTH_CHECK, payload)];

        case 12:
          _b.sent();

          return [3
          /*break*/
          , 16];

        case 13:
          error_1 = _b.sent();
          return [4
          /*yield*/
          , effects_1.call(authProvider, auth_1.AUTH_LOGOUT)];

        case 14:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.put(react_router_redux_1.replace({
            pathname: error_1 && error_1.redirectTo || '/login',
            state: {
              nextPathname: meta.pathName
            }
          }))];

        case 15:
          _b.sent();

          return [3
          /*break*/
          , 16];

        case 16:
          return [3
          /*break*/
          , 29];

        case 17:
          return [4
          /*yield*/
          , effects_1.put(react_router_redux_1.push(action.payload && action.payload.redirectTo || '/login'))];

        case 18:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.call(authProvider, auth_1.AUTH_LOGOUT)];

        case 19:
          _b.sent();

          return [3
          /*break*/
          , 29];

        case 20:
          _b.trys.push([20, 22,, 28]);

          return [4
          /*yield*/
          , effects_1.call(authProvider, auth_1.AUTH_ERROR, error)];

        case 21:
          _b.sent();

          return [3
          /*break*/
          , 28];

        case 22:
          e_2 = _b.sent();
          return [4
          /*yield*/
          , effects_1.select(currentPathnameSelector)];

        case 23:
          nextPathname = _b.sent();
          return [4
          /*yield*/
          , effects_1.call(authProvider, auth_1.AUTH_LOGOUT)];

        case 24:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.put(react_router_redux_1.push({
            pathname: '/login',
            state: {
              nextPathname: nextPathname
            }
          }))];

        case 25:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.put(notificationActions_1.hideNotification())];

        case 26:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.put(notificationActions_1.showNotification('ra.notification.logged_out', 'warning'))];

        case 27:
          _b.sent();

          return [3
          /*break*/
          , 28];

        case 28:
          return [3
          /*break*/
          , 29];

        case 29:
          return [2
          /*return*/
          ];
      }
    });
  }

  return function watchAuthActions() {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.all([effects_1.takeEvery(function (action) {
            return action.meta && action.meta.auth;
          }, handleAuth), effects_1.takeLatest(fetchActions_1.FETCH_ERROR, handleAuth)])];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };
};